import { render, staticRenderFns } from "./AdministratorIssueReportDataUpload.vue?vue&type=template&id=06dc6442&scoped=true&"
import script from "./AdministratorIssueReportDataUpload.vue?vue&type=script&lang=js&"
export * from "./AdministratorIssueReportDataUpload.vue?vue&type=script&lang=js&"
import style0 from "./AdministratorIssueReportDataUpload.vue?vue&type=style&index=0&id=06dc6442&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06dc6442",
  null
  
)

export default component.exports